import footer1_Init from "@common/components/footer-1";
import Swiper from "swiper11";
import { Navigation, Pagination, Autoplay } from "swiper11/modules";
import { globalSearch, initSearch, fixedsHeader, initFancyBox } from "@common/utils/initUtils";
import { ImportBundle, lazyLoad } from "@common/utils/utils";
import { countUp, registerBootstrap } from "@common/utils/additionalUtils";
import dialogFormInit from "@common/components/dialogForm-1";
import Modal from "@common/bootstrapComponents/Modal.mjs";
import Tab from "@common/bootstrapComponents/Tab.mjs";
import { isIndex } from "@common/utils/verification";
$(function () {
  if (window.innerWidth === 1350 || window.innerWidth === 412) {
    $(document).one("mousemove", () => {
      initFunction();
    });
    $(document).one("scroll", () => {
      initFunction();
    });
  } else {
    initFunction();
  }
});

function initFunction() {
  registerBootstrap(Modal, Tab);
  initEvent();
  initSwiper();
  ImportBundle({ type: "css", onlyIndex: true }, [
    "https://static.yigetechcms.com/public/css/bootstrap@4.6.2.min.css",
    "https://static.yigetechcms.com/public/css/swiper-bundle@11.1.1.min.css",
  ]);
  initFancyBox();
}

function initEvent() {
  if (isIndex()) {
    dialogFormInit();
  }
  footer1_Init();
  lazyLoad();
  countUp();
  fixedsHeader("header-6");
  initSearch();
  globalSearch();
  slideDownAnime($(".index-6 .index-6-service .service-right .list > li > article > header"));
  (() => {
    const img = $(".index-6 .index-6_solution .solution-left .img-box img");
    const imgUrl = $(".index-6 .index-6_solution .solution-right .tab-content .tab-pane").first().attr("data-img")!;
    setImgUrl(img, imgUrl);

    $(".index-6 .index-6_solution .solution-right .nav [data-toggle=tab]").on("show.bs.tab", (e) => {
      const img = $(".index-6 .index-6_solution .solution-left .img-box img");
      const imgUrl = $($(e.currentTarget).attr("data-target")!).attr("data-img");
      setImgUrl(img, imgUrl);
    });
  })();
  $(".index-6_product .swiper-box .swiper-slide a article footer").on("click", (e) => {
    e.preventDefault();
  });
}

function slideDownAnime(list: JQuery) {
  const heightList: any[] = list.toArray().map((i) => {
    const H = $(i).offset()!.top - $(i).offsetParent().offset()!.top + $(i).outerHeight()!;
    const markerH = H - $(i).outerHeight()! + $(i).height()! / 2;
    return {
      marker: markerH,
      h: H,
    };
  });
  list.on("click", (e) => {
    const idx = $(e.currentTarget).parents("li").index();
    $(".index-6 .index-6-service .service-right").css("--progress", heightList[idx].h + "px");
    $(".index-6 .index-6-service .service-right").css("--mark", heightList[idx].marker + "px");
    $(e.currentTarget).siblings(".index-6-des").slideDown(350).parents("li").siblings().find(".index-6-des").slideUp(350);
  });
  list.first().trigger("click");
}

function setImgUrl(target: JQuery, url: string | undefined) {
  if (!target.length || !url || url === "") return;
  target.attr("src", url);
}

function initSwiper() {
  new Swiper(".index-6 .index-6_banner .swiper-box .swiper", {
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    speed: 1500,
    autoplay: {
      disableOnInteraction: false,
      delay: 5500,
    },
    pagination: {
      el: ".index-6 .index-6_banner .swiper-box .custom-swiper-pagination",
      clickable: true,
    },
    navigation: {
      prevEl: ".index-6 .index-6_banner .swiper-box .prev",
      nextEl: ".index-6 .index-6_banner .swiper-box .next",
    },
  });

  new Swiper(".index-6 .index-6_product .swiper-box .swiper", {
    modules: [Navigation],
    loop: true,
    slidesPerView: 3,
    spaceBetween: 30,
    navigation: {
      prevEl: ".index-6 .index-6_product .swiper-box .prev",
      nextEl: ".index-6 .index-6_product .swiper-box .next",
    },
    breakpoints: {
      1200: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      620: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
      320: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
    },
  });
}
